import {IFileDetailsStoreState} from './IFileDetailsStoreState';

export const fileDetailsInitialState: IFileDetailsStoreState = {
  page: {
    loading: false,
    fileDownloading: false,
    formRevision: 0,
  },
  fileDetails: null,
};
